import { updateKeyInStore } from 'App';
import { store } from 'app/redux/store';
import * as Yup from 'yup';
import { requiredFiles } from '../../useValidateQuestionnaire';
import {
  DeductionsStateValues,
  TListOfChildcareProvidersRow,
  updateFieldArrayKey,
  updateKey,
} from './slice';

export const fields: IBaseField<
  keyof DeductionsStateValues | keyof TListOfChildcareProvidersRow
>[] = [
  {
    name: 'doYouWantToListVariousExpensesThatMightImproveYourTaxPosition',
    label:
      'Do you want to list various expenses that might improve your tax position?',
    type: 'radio',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    dependencies: [
      {
        dependenciesTitle: 'Financial',
        name: 'investmentExpenses',
        label: 'Investment expenses',
        type: 'currency',
        predicate: (value) => value === 'yes',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
      },
      {
        name: 'didYouPayAWealthTaxieTaxOnAssetsAndNotIncome',
        label: 'Did you pay a Wealth Tax (ie tax on assets and not income)?',
        type: 'radio',
        predicate: (value) => value === 'yes',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
        dependencies: [
          {
            name: 'didYouPayAWealthTaxieTaxOnAssetsAndNotIncomedetailsAboutTaxPaid',
            label: 'Details about tax paid',
            type: 'text',
            predicate: (value) => value === 'yes',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
            placeholder: 'Enter',
          },
          {
            name: 'didYouPayAWealthTaxieTaxOnAssetsAndNotIncometaxAmount',
            label: 'Tax Amount',
            type: 'currency',
            predicate: (value) => value === 'yes',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
          },
        ],
      },
      {
        name: 'didYouPayAnInheritanceTax',
        label: 'Did you pay an inheritance Tax?',
        type: 'radio',
        predicate: (value) => value === 'yes',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
        dependencies: [
          {
            name: 'didYouPayAnInheritanceTaxdetailsAboutTaxPaid',
            label: 'Details about tax paid',
            type: 'text',
            predicate: (value) => value === 'yes',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
            placeholder: 'Enter',
          },
          {
            name: 'didYouPayAnInheritanceTaxtaxAmount',
            label: 'Tax Amount',
            type: 'currency',
            predicate: (value) => value === 'yes',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
          },
        ],
      },
      {
        dependenciesTitle: 'Housing',
        name: 'didYouOwnResidentialRealEstateDuringYear',
        label: 'Did you own residential real estate during the selected year?',
        type: 'radio',
        predicate: (value) => value === 'yes',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
        dependencies: [
          {
            label: () => (
              <>
                <p>
                  Please note - if you rented the property, provide details in
                  the Passive Income tab. Please DO NOT provide the details
                  about mortgage / property taxes paid below (so we don't
                  double-count them).
                </p>
                <p>
                  The minimum number of rental days at which the property must
                  be reported as a rental is 14 (even if you live in it for the
                  rest of the year).
                </p>
                <p>
                  If you own multiple properties, please list the mortgages and
                  property taxes separately for each property - you can provide
                  expanded details by clicking on the pencil icon next to the
                  question
                </p>
              </>
            ),
            type: 'information',
            predicate: (value) => value === 'yes',
          },
          {
            name: 'doYouHaveAMortgagePleaseUploadForm1098',
            label: 'Do you have a Mortgage, please upload Form 1098',
            type: 'upload',
            predicate: (value) => value === 'yes',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
          },
          {
            name: 'ifNonUsMortgagePleaseUploadBankStatementShowingTheAmountOfMortgageInterestPaidThroughTheCalendarYear',
            label:
              'If Non-US mortgage, please upload bank statement showing the amount of mortgage interest paid through the calendar year',
            type: 'upload',
            predicate: (value) => value === 'yes',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
          },
          {
            name: 'didYouPayPropertyTaxesOnTheResidence',
            label: 'Did you pay property taxes on the residence?',
            type: 'radio',
            predicate: (value) => value === 'yes',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
            dependencies: [
              {
                name: 'propertyTaxesPaidOnForeignResidence',
                label: 'Property taxes paid on foreign residence',
                type: 'currency',
                predicate: (value) => value === 'yes',
                tooltip: '',
                comment: true,
                effect: updateKeyInStore(updateKey),
              },

              {
                name: 'propoertyTaxesPaidOnUsResidence',
                label: 'Propoerty taxes paid on US residence',
                type: 'currency',
                predicate: (value) => value === 'yes',
                tooltip: '',
                comment: true,
                effect: updateKeyInStore(updateKey),
              },
            ],
          },
        ],
      },

      {
        name: 'doYouHaveATimeShareThatReportedPropertyTaxesPaid',
        label: 'Do you have a time share that reported Property taxes Paid?',
        type: 'radio',
        predicate: (value) => value === 'yes',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
      },
      {
        dependenciesTitle: 'Healthcare',
        name: 'doYouHaveAnHsaAccount',
        label: 'Do you have an HSA account?',
        type: 'radio',
        predicate: (value) => value === 'yes',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
        dependencies: [
          {
            name: 'pleaseUploadForms5498SaAnd1099SaIfReceived',
            label: 'Please upload Forms 5498-SA and 1099-SA if received',
            type: 'upload',
            predicate: (value) => value === 'yes',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
          },
        ],
      },
      {
        name: 'medicalAndDentalExpensesinsurancePremiums',
        label: 'Medical and dental expenses/insurance premiums',
        subLabel: () => (
          <p>
            This is only applicable if the amount is more than 10% of gross
            income
          </p>
        ),
        type: 'currency',
        predicate: (value) => value === 'yes',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
      },
      {
        name: 'didYouIncurChildcareOrOtherDependentCareExpenses',
        label: 'Did you incur childcare or other dependent care expenses?',
        type: 'radio',
        predicate: (value) => value === 'yes',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
        dependencies: [
          {
            name: 'listOfChildcareProviders',
            label: 'List of Childcare Providers',
            type: 'fieldArray',
            predicate: (value) => value === 'yes',
            tooltip: '',
            comment: true,
            effect: (payload) => store.dispatch(updateFieldArrayKey(payload)),
            defaultDependency: {
              namesOfChildcareProvider: null,
              address: null,
              socSecOrEmployerIdOfChildcareProvider: null,
              amountPaid: null,
            },
            dependencies: [
              {
                name: 'namesOfChildcareProvider',
                label: 'Names of Childcare Provider',
                type: 'text',
                tooltip: '',
                comment: true,
                effect: updateKeyInStore(updateKey),
                placeholder: 'Enter',
              },
              {
                name: 'address',
                label: 'Address',
                type: 'text',
                tooltip: '',
                comment: true,
                effect: updateKeyInStore(updateKey),
                placeholder: 'Enter',
              },
              {
                name: 'socSecOrEmployerIdOfChildcareProvider',
                label: 'Soc. Sec or Employer ID of childcare provider',
                type: 'text',
                tooltip: '',
                comment: true,
                effect: updateKeyInStore(updateKey),
                placeholder: 'Enter',
              },
              {
                name: 'amountPaid',
                label: 'Amount Paid',
                type: 'currency',
                tooltip: '',
                comment: true,
                effect: updateKeyInStore(updateKey),
              },
            ],
          },
        ],
      },
      {
        label: () => (
          <>
            <p>
              Childcare means establishments (or individuals) that provide child
              welfare and safety. Establishments that fully or partially provide
              education are not eligible - neither in the U.S. or abroad. Thus a
              daycare facility would be eligible, while a kindergarten or
              preschool would not.\nVery important - please do not report child
              care expenses for children who are over 12 years old by the end of
              reporting year.
            </p>
            <p>
              If you do - you run a very high chance of being audited by the
              IRS. Likewise do not report expenses for overnight camp or
              extracurricular programs where children must be accompanied by
              parents.
            </p>
          </>
        ),
        type: 'information',
        predicate: (value) => value === 'yes',
      },

      {
        dependenciesTitle: 'Education',
        name: 'didYouPayInterestOnStudentLoans',
        label: 'Did you pay Interest on Student Loans?',
        type: 'upload',
        predicate: (value) => value === 'yes',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
        dependencies: [
          {
            name: 'form1098E',
            label: 'Form 1098E',
            type: 'upload',
            predicate: (value) => value === 'yes',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
          },
        ],
      },
      {
        name: 'didYouIncurHigherEducationExpensesForYourselfSpouseOrDependents',
        label:
          'Did you incur higher education expenses for yourself, spouse or dependents',
        subLabel: () => <p>Higher education refers to college & beyond</p>,
        type: 'radio',
        predicate: (value) => value === 'yes',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
        dependencies: [
          {
            name: 'form1098T',
            label: 'Form 1098T',
            type: 'upload',
            predicate: (value) => value === 'yes',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
          },
        ],
      },
      {
        dependenciesTitle: 'Donations',
        name: 'charitableContributionsToUsOrForeignQualifiedOrganizationscandianMexianOrIsraeli',
        label:
          'Charitable contributions to US or foreign qualified organizations (Candian, Mexian, or Israeli)',
        type: 'currency',
        predicate: (value) => value === 'yes',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
      },
      {
        name: 'didYouDonateAVehicleBoatOrAirplaneWithTheClaimedValueOver500',
        label:
          'Did you donate a vehicle, boat or airplane with the claimed value over $500?',
        type: 'radio',
        predicate: (value) => value === 'yes',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
        dependencies: [
          {
            name: 'form1098C',
            label: 'Form 1098C',
            type: 'upload',
            predicate: (value) => value === 'yes',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
          },
        ],
      },

      {
        dependenciesTitle: 'Other expenses',
        name: 'pleaseListAnyOtherItemsOfIncomeOrExpenseThatYouThinkMayImpactYourUsTaxes',
        label:
          'Please list any other item(s) of income or expense that you think may impact your US taxes',
        type: 'text',
        predicate: (value) => value === 'yes',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
        placeholder: 'Enter',
      },
      {
        name: 'casualtyAndTheftLossesFromAUsFederallyDeclaredDisaster',
        label:
          'Casualty and theft loss(es) from a US federally declared disaster',
        type: 'currency',
        predicate: (value) => value === 'yes',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
      },
    ],
  },
  {
    name: 'doesTheJobRelatedExpensesExceedsTheStandardDeduction',
    label: () => (
      <p>
        Does the Job related expenses exceeds the Standard Deduction? ie check{' '}
        <a
          className="text-green"
          href="irs.gov"
          target="_blank"
          rel="noreferrer noopener"
        >
          irs.gov
        </a>{' '}
        for standard deduction
      </p>
    ),
    type: 'radio',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    dependencies: [
      {
        name: 'pleaseUploadAllTheRelatedDeductions',
        label: 'Please upload all the related deductions',
        type: 'upload',
        predicate: (value) => value === 'yes',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
      },
    ],
  },
  {
    name: 'didYouExperienceALossOfMoreThan10OfYourIncomeDueToCasualtyOrTheft',
    label:
      'Did you experience a loss of more than 10% of your income due to casualty or theft?',
    type: 'radio',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
  },

  {
    name: 'didYouDonatePhysicalGoodsThisYear',
    label: 'Did you donate physical goods this year?',
    type: 'radio',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
  },
];

export const validationSchema = Yup.object().shape({});
